import { render, staticRenderFns } from "./DefaultNotificationTemplateMessage.vue?vue&type=template&id=74e8ef55&scoped=true"
import script from "./DefaultNotificationTemplateMessage.vue?vue&type=script&lang=js"
export * from "./DefaultNotificationTemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./DefaultNotificationTemplateMessage.vue?vue&type=style&index=0&id=74e8ef55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e8ef55",
  null
  
)

export default component.exports